// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	BackButton: 'back-button',
	PrintButton: 'print-button',
	EmailButton: 'email-button',
	SendToLenderButton: 'send-to-lender-button',
	ExportAsPdfButton: 'export-as-pdf-button',
	PrepareForESigningButton: 'prepare-for-e-signing-button',
	DropdownBackButton: 'dropdown-back-button',
	AddButton: 'add-button',
	Dropdown: 'dropdown',
	EditMergeDocumentButton: 'edit-merge-document-button',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
